<template>
    <rkm-modal
        :buttons="['cancel']"
        :loading="loading"
        large
        ref="Modal"
        title="Medicamentos"
    >
        <rkm-list
            :items="materiais"
            hide-filters
        >
            <template v-slot="{ item }">
                <span><strong>Livro:</strong> {{ item.livro }}</span> <span v-if="!!item.tipo"><strong>Tipo:</strong> {{ item.tipo }}</span>
            </template>

            <template v-slot:collapse="{ item }">
                <div class="p-2">
                    <rkm-row>
                        <rkm-col>
                            <rkm-table
                                :fields="fields"
                                :items="item.materiais"
                                hide-filters
                                sort-by="material"
                            />
                        </rkm-col>
                    </rkm-row>
                </div>
            </template>
        </rkm-list>
    </rkm-modal>
</template>

<script>
// Vuex.
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        fields() {

            return [
                {
                    key: 'descricao',
                    label: 'Medicamento',
                    sortable: true,
                    searchable: true,
                },
            ]
        }
    },
    methods: {
        open() {

            this.$refs.Modal.show()
        },
    },
    props: {
        materiais: { type: Array, required: true },
    }
}
</script>